module.exports = __webpack_public_path__ + "img/9f61370.jpg";